module.exports = [{"type":"hash","text":"Unsubscribe"},{"type":"normal","text":"The format of unsubscription is as follows:"},{"type":"code","text":"{ \"id\": \"id1\", \"reqType\": \"unsub\", \"dataType\": \"data to unsub\"}"},{"type":"normal","text":"Confirmation of Unsubscription:"},{"type":"code","text":"{ \"id\": \"id1\", \"code\": 0, \"msg\": \"\" }"}]


//////////////////
// WEBPACK FOOTER
// ./src/config/en-US/swapV2/websocket/introduce/05_cancel_subscribe.json
// module id = 7k03
// module chunks = 3